export default __webpack_public_path__ + "static/media/igloo_2.c2430973.jpg";